// extracted by mini-css-extract-plugin
export default {"mobileActionBar":"MobileCategories_mobileActionBar__XJ9qT","mobileTabs":"MobileCategories_mobileTabs__OHQrq"};